import 'jquery.cookie';
import wildcardDomain from '@/js/common/Domain/Service/wildcardDomain';

import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => {
    const tourCriteria = {
        showcase: window.appConfig.showcaseCode,
        ...tourCriteriaForTourRequest,
    };

    if ($.cookie('markSearchSource')) {
        tourCriteria.source = 'userSearch';
        $.removeCookie('markSearchSource', { path: '/', domain: wildcardDomain() });
    }

    const options = {
        cache: false,
        data: tourCriteria,
        type: 'POST',
        url: `${window.appConfig.apiGatewayUrl}/frontend/tours/asyncSearch`,
    };

    return requestService(options, callback);
};
